/**
 *  IMPORTANT
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */

exports.SPA_SSR_RENDERED_MARK = "ssr.spa.rendered";

/*::
export type JsEvalStart = ':eval-start';
 */
const JS_EVAL_START /*:: :JsEvalStart */ = ":eval-start";
exports.JS_EVAL_START = JS_EVAL_START;

/*::
export type JsEvalStop = ':eval-stop';
 */
const JS_EVAL_STOP /*:: :JsEvalStop */ = ":eval-stop";
exports.JS_EVAL_STOP = JS_EVAL_STOP;

/*::
export type JsEvalApi = '__jsEvalStop';
*/
const JS_EVAL_API /*:: :JsEvalApi */ = "__jsEvalStop";
exports.JS_EVAL_API = JS_EVAL_API;
